import {ContentBox} from "../../../Common/component/MainScaffold";
import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../../../context/AuthContext";
import {getRequest} from "../../../../api/postRequest";
import {NahrainLogger} from "../../../../debug/NahrainLogger";
import {CircularProgress} from "@mui/material";
import {useTranslation} from "react-i18next";

export const SelectCurriculumDialogSidebar = ({onClickContinue}) => {
    const [loading, setLoading] = useState(true);
    const [curriculums, setCurriculums] = useState(null);
    const [selectedCurriculumId, setSelectedCurriculumId] = useState(null)
    const [t] = useTranslation("global");
    const maxWidth = "max-w-[700px]";

    const {accessToken} = useContext(AuthContext);
    useEffect(() => {
        const fetchUserData = () => {
            setLoading(true);
            getRequest({
                    path: `prof/curriculums`,
                    token: accessToken,
                    onSuccess: (response) => {
                        setCurriculums(response.payload);
                        setLoading(false);
                    },
                    onError: (err) => {
                        NahrainLogger.error(err);
                        setLoading(false);
                    }
                }
            );
        };

        fetchUserData();
    }, [ accessToken]);

    if (loading) {
        return (
            <div className="w-full h-full flex justify-center items-center">
                <CircularProgress/>
            </div>
        );
    }

    return (
        <div className={`flex flex-col h-full justify-between`}>
            <div>
                <div className={`flex flex-col gap-4`}>
                    {curriculums.map((curriculum) => (
                        <ContentBox
                            className={`mx-auto ${maxWidth}`}
                            onClick={() => setSelectedCurriculumId(curriculum.id)}
                            enabled={selectedCurriculumId === curriculum.id}
                            title={curriculum.name}
                            description={t(curriculum.stageType.toLowerCase())}
                        />
                    ))}
                </div>
            </div>

            <button
                onClick={() => selectedCurriculumId !== null ? onClickContinue(selectedCurriculumId) : null}
                className={`${maxWidth} bg-primary w-full mx-auto text-white h-14 rounded-lg text-[24px] mb-6`}
            >
                {t("next_button")}
            </button>
        </div>
    );
}